import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

import { InputCrmAnhangAttachementsRelation } from './InputCrmAnhangAttachementsRelation.entity';
import { InputTopicMarkRelation } from './InputTopicMarkRelation.entity';

export class InputTelefonatRelation<T extends EMode = EMode.entity> {
  /** Alias: attachements */
  attachements?: InputCrmAnhangAttachementsRelation<T>;
  /** Alias: topic */
  topic?: InputTopicMarkRelation<T>;

  __typename?: string;
}

const fields: FieldDefinitions<InputTelefonatRelation> = {
  attachements: {
    alias: 'attachements',
  },
  topic: {
    alias: 'topic',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputTelefonatRelationEntityDefinition: EntitiyDefinition<InputTelefonatRelation> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputTelefonatRelation',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
